import type { BackendTypes } from '@tf/api';
import type { ConnectedEntity, StructureEntity } from '@/components/structure/useStructureEntities';

type FormInfo = ConnectedEntity['forms'][number];

export interface EntityFormsContext {
	entityId?: BackendTypes.GraphId;
	parentEntityId?: BackendTypes.GraphId;
	connectionKind?: BackendTypes.EntityConnectionKind;
}

export const getEntityForms = (
	entities: StructureEntity[],
	{ entityId, parentEntityId, connectionKind }: EntityFormsContext,
): FormInfo[] | undefined => {
	const entity = entities.find((e) => e.entityId === entityId);

	if (parentEntityId === undefined || connectionKind === undefined) {
		return entity?.forms;
	}

	const connectedEntity = entities
		.find((e) => e.entityId === parentEntityId)
		?.connections.find((c) => c.connectionKind === connectionKind)
		?.connectedEntities?.find((e) => e.entityId === entityId);

	if (!entity || !connectedEntity) return undefined;

	return [...entity.forms, ...connectedEntity.forms];
};
